import * as angular from 'angular';
import * as Highcharts from 'highcharts/highstock';
import controller from './dashboard.controller';

export default angular.module('aps.directive.highChart', [controller])
    .directive('highChart', ['$window', highChart])
    .name;

function highChart($window: any) {
    return {
        restrict: 'E',
        template: '<div></div>',
        scope: {
            options: '='
        },
        link: function (scope: any, element: any, attrs: any) {
            var el = element;

            var onResize = function (event: any) {
                if (chart) {
                    chart.reflow();
                    scope.$apply();
                    // console.log('resize', chart);
                    // console.log('element.height()', el.height());
                }
            };

            var cleanUp = function () {
                angular.element($window).off('resize', onResize);
            };

            angular.element($window).bind('resize', onResize);

            scope.$watch('options', function (newVal: any) {
                if (newVal) {
                    chart = Highcharts.chart(element[0], scope.options);
                    // console.log("options.changed", newVal);
                }
            }, true);

            scope.$on('$destroy', cleanUp);

            var chart = Highcharts.chart(attrs["id"], scope.options);
            chart.reflow();
            // console.log("attrs", attrs);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/dashboard/dashboard.directives.ts